import React from "react";

export default function HorizontalDivider() {
    return (
        <hr className={'text-gray-200'}></hr>
    )
}